import Link from "next/link";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";

type BlogSearchFormProps = {
  q: string;
  tag: string;
  tags: string[];
};

export function BlogSearchForm({ q, tag, tags }: BlogSearchFormProps) {
  return (
    <div className="space-y-4">
      <form method="GET" action="/blog" className="flex w-full gap-2">
        <Input
          type="text"
          name="q"
          defaultValue={q}
          placeholder="Search blog posts"
          aria-label="Search posts"
        />
        {tag ? <input type="hidden" name="tag" value={tag} /> : null}
        <Button type="submit">Search</Button>
      </form>

      <div className="flex flex-wrap items-center gap-2">
        <Link
          href={{
            pathname: "/blog",
            query: q ? { q } : undefined,
          }}
          className={cn(
            "rounded-full border px-3 py-1 text-xs transition-colors",
            !tag
              ? "bg-primary text-primary-foreground"
              : "bg-background text-foreground hover:bg-foreground/5"
          )}
        >
          All tags
        </Link>

        {tags.map((tagName) => {
          const isActive = tagName === tag;
          return (
            <Link
              key={tagName}
              href={{
                pathname: "/blog",
                query: {
                  ...(q ? { q } : {}),
                  tag: tagName,
                },
              }}
              className={cn(
                "rounded-full border px-3 py-1 text-xs transition-colors",
                isActive
                  ? "bg-primary text-primary-foreground"
                  : "bg-background text-foreground hover:bg-foreground/5"
              )}
            >
              {tagName}
            </Link>
          );
        })}
      </div>
    </div>
  );
}
